<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="blackChildUpdate"  @submit="blackSubmit" :updateData="blackUpdateData" @uploadFile="uploadFile"></UPDATE>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData">
      <template v-slot:luckyDrawConditions="update">
        <!--条件列表-->
        <conditions-group :update="update"></conditions-group>
      </template>
      <template v-slot:luckyDrawPrizes="update">
        <!--奖品列表-->
        <prize :update="update"></prize>
      </template>
      <template v-slot:luckyDrawSpecials="update">
        <!--特殊设置列表-->
        <specials :update="update"></specials>
      </template>
    </UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import conditionsGroup from '@/views/crs36/luckyDraw/conditionsGroup.vue'
  import prize from '@/views/crs36/luckyDraw/prize.vue'
  import specials from '@/views/crs36/luckyDraw/specials.vue'
  import Url from '@/views/crs36/util/url'
  import Qs from 'qs'
  const status = {"1":"已启用","2":"已停用","3":"已结束","4":"待审核"};
  const tradePlatform = {"GTS2":"PTS","MT5":"MT5"};
  const partake = {"MIN":"迷你","STD":"标准","PLA":"铂金","ZER":"巴菲特","MIN2":"迷你2","STD2":"标准2","PLA2":"铂金2"};
  const luckyDrawStatus = {"1":"活动期","2":"每日"};
  export default {
    name: 'lucky',
    components: {
      tablePage,
      FORM,
      UPDATE,
      conditionsGroup,
      prize,
      specials,
    },
    methods: {
      uploadFile(col,result){
        col.data = (result || []).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.axios.post(Url.luckyDraw.lucky.info, Qs.stringify({id:row.id})).then(res => {
            if (res.code == 0){
              row = res.result;
              row.activeTime = [row.startTime,row.endTime];
              row.partake = row.partake.split(",");
              for (const i in row.luckyDrawConditions) {
                for (const j in row.luckyDrawConditions[i].luckyDrawConditionEntities){
                   if (row.luckyDrawConditions[i].luckyDrawConditionEntities[j].type == 5){
                     row.luckyDrawConditions[i].luckyDrawConditionEntities[j].typeValue = row.luckyDrawConditions[i].luckyDrawConditionEntities[j].typeValue.split(",");
                     row.luckyDrawConditions[i].luckyDrawConditionEntities[j].conditionsProductType = row.luckyDrawConditions[i].luckyDrawConditionEntities[j].conditionsProductType.split(",");
                   }
                }
              }
              this.$refs.childUpdate.open(row);
            }
          })
        }else if(clickName == "apply"){
          this.dataChanage(Url.luckyDraw.lucky.applyStatus,{id:row.id,status:1},res => {
            if (res.code == 0){
              this.$refs.childUpdate.close();
              this.$message.success("suc");
            }else{
              this.$message.error(res.message);
            }
            this.$refs.childTable.defaultGetData(this.queryData);
          })
        }else if(clickName == "copy"){
          this.axios.post(Url.luckyDraw.lucky.info, Qs.stringify({id:row.id})).then(res => {
            if (res.code == 0){
              row = res.result;
              row.activeTime = [row.startTime,row.endTime];
              row.partake = row.partake.split(",");
              for (const i in row.luckyDrawConditions) {
                for (const j in row.luckyDrawConditions[i].luckyDrawConditionEntities){
                  if (row.luckyDrawConditions[i].luckyDrawConditionEntities[j].type == 5){
                    row.luckyDrawConditions[i].luckyDrawConditionEntities[j].typeValue = row.luckyDrawConditions[i].luckyDrawConditionEntities[j].typeValue.split(",");
                    row.luckyDrawConditions[i].luckyDrawConditionEntities[j].conditionsProductType = row.luckyDrawConditions[i].luckyDrawConditionEntities[j].conditionsProductType.split(",");
                  }
                }
              }
              row.id = null;
              this.$refs.childUpdate.open(row);
            }
          })
        }else if(clickName == "delete") {
          this.dataChanage(Url.luckyDraw.lucky.delete, {id:row.id}, res => {
              if (res.code == 0) {
                this.$message.success("suc");
              } else {
                this.$message.error(res.message);
              }
              this.$refs.childTable.defaultGetData(this.queryData);
            }
          )
        }else if(clickName == "black") {
          row.luckyDrawId = row.id;
          this.$refs.blackChildUpdate.open(row);
        }else if(clickName == "user") {
          this.$router.push({path: '/crs36/luckyDraw/user',query:{label:"CRS36",luckyDrawId:row.id}});
        }else if(clickName == "record") {
          this.$router.push({path: '/crs36/luckyDraw/record',query:{label:"CRS36",luckyDrawId:row.id}});
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t('crs36.bt.search') == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(data);
        }else if(window.$t('crs36.bt.add') == clickName){
          this.$refs.childUpdate.open();
        }
      },
      blackSubmit(model){
        this.dataChanage(Url.luckyDraw.lucky.importBlack,model,res => {
          if (res.code == 0){
            this.$refs.blackChildUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error(res.message);
          }
          //this.$refs.childTable.defaultGetData(this.queryData);
        })
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        model.startTime = model.activeTime[0];
        model.endTime = model.activeTime[1];
        model.partake = model.partake.join(",");
        for (const i in model.luckyDrawConditions) {
          for (const j in model.luckyDrawConditions[i].luckyDrawConditionEntities){
            if (model.luckyDrawConditions[i].luckyDrawConditionEntities[j].type == 5){
              model.luckyDrawConditions[i].luckyDrawConditionEntities[j].typeValue = model.luckyDrawConditions[i].luckyDrawConditionEntities[j].typeValue.join(",");
              model.luckyDrawConditions[i].luckyDrawConditionEntities[j].conditionsProductType = model.luckyDrawConditions[i].luckyDrawConditionEntities[j].conditionsProductType.join(",");
            }
          }
        }
        this.jsonChanage(Url.luckyDraw.lucky.save,model,res => {
            if (res.code == 0){
                this.$refs.childUpdate.close();
                this.$message.success("suc");
            }else{
                this.$message.error(res.message);
            }
            this.$refs.childTable.defaultGetData(this.queryData);
        })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
          if(suc && (typeof suc == 'function')) suc(res);
        }).catch(res => {
            if(fail && (typeof fail == 'function')) fail(res);
        })
      },
      jsonChanage(url,option,suc,fail){
        this.axios.post(url, JSON.stringify(option), { headers: { 'Content-Type': 'application/json' } }).then(res => {
          if(suc && (typeof suc == 'function')) suc(res);
        }).catch(res => {
            if(fail && (typeof fail == 'function')) fail(res);
        })
      }
    },
    data () {
      return {
        queryData:{},
        /*新增或更新*/
        blackUpdateData:{
          cols:[
            { title: "luckyDrawId", field: 'luckyDrawId',hidden:true},
            { title: "黑名单", field: 'userList',type:11,action:Url.pushMsg.uploadTemplate,downUrl:"https://static.chwenda.com/source/downloadModel/消息推送用户模板.xlsx"},
          ]
        },
        updateData:{
          cols:[
            { title: "id", field: 'id',hidden:true},
            { title: "isBy", field: 'isBy',hidden:true},
            { title: "status", field: 'status',hidden:true},
            { title: "活动名称", field: 'name',required:true},
            { title: "活动名称EN", field: 'nameEn',required:true},
            { title: "活动名称VN", field: 'nameVn',required:true},
            { title: "活动时间", field: 'activeTime',type:9,required:true,format: 'yyyy-MM-dd HH:mm:ss',data:[],readonly:(model,col)=>{
                return (model.id && model.isBy == 1)?true:false;
              }},
            { title: "活动规则EN", field: 'describeEn',type:14},
            { title: "活动规则VN", field: 'describeVn',type:14},
            { title: "参与用户", field: 'partake',type: 4,optionList: partake,data:[],required:true,readonly:(model,col)=>{
                return (model.id && model.isBy == 1)?true:false;
              }},
            { title: "交易平台", field: 'tradePlatform',type: 2,optionList:tradePlatform,required:true,readonly:(model,col)=>{
                return (model.id && model.isBy == 1)?true:false;
              }},
            { title: "上限状态", field: 'luckyDrawStatus',data: 1,hidden:true},
            { title: "抽奖上限", field: 'luckyDrawSum',type: 7,required:true,readonly:(model,col)=>{
                return (model.id && model.isBy == 1)?true:false;
              }},
            { title: "条件组", field: 'luckyDrawConditions',type:10,slot:'luckyDrawConditions',required:true,data:[{"startTime":"","endTime":"","count":"","luckyDrawConditionEntities":[{"type":"","typeValue":0,"conditionsProductType":""}]}]},
            { title: "奖品设置", field: 'luckyDrawPrizes',type:10,slot:'luckyDrawPrizes',required:true,data:[{"name":"","bonus":"","number":"","probabilityMin":"","probabilityStd":"","probabilityPla":"","probabilityZer":"","dayUpperLimit":"","sumUpperLimit":""}]},
            { title: "特殊设置", field: 'luckyDrawSpecials',type:10,slot:'luckyDrawSpecials',required:true,data:[{"phone":"","name":"","bonus":""}]},
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: "活动名称", field: 'name'},
              { title: "状态", field: 'status',type:2,optionList:status},
              {title: "创建时间",field: 'time',type: 6,format: 'yyyy-MM-dd HH:mm:ss',startEndParam: ['startTime', 'endTime']},
              {click: window.$t('crs36.bt.search'),auth:"crs36.lucky.query"},
              {click: window.$t('crs36.bt.add'),auth:"crs36.lucky.add"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.luckyDraw.lucky.query, //请求路径和参数
          //selection: true,
          sequence: true,
          cols: [
              { title: "活动ID", field: 'id'},
              { title: "活动名称", field: 'name'},
              { title: "活动开始时间", field: 'startTime'},
              { title: "活动结束时间", field: 'endTime'},
              { title: "参与用户", field: 'partake',render:(data,full)=>{
                  let split = data.split(",");
                  return split.map(key => partake[key]).join(",");
                }},
              { title: "状态", field: 'status',render:(data,full)=>{
                  return status[data];
                }},
              { title: "交易平台", field: 'tradePlatform'},
              { title: "创建者", field: 'creator'},
              { title: "创建时间", field: 'createDate'},
              { title: "更新时间", field: 'updateDate'},
              {title: window.$t('crs36.bt.operation'),width: 600,btnClick:[
                  {name: window.$t('crs36.bt.edit'),click:"update",type:"primary",icon:"el-icon-edit",auth:"crs36.lucky.update"},
                  {name: "复制",click:"copy",type:"primary",icon:"el-icon-edit",auth:"crs36.lucky.update"},
                  {name: "黑名单",click:"black",type:"primary",icon:"el-icon-edit"},
                  {name: "审核",click:"apply",type:"primary",icon:"el-icon-edit",auth:"crs36.lucky.apply",confirm:true,hidden:(data,full)=>{
                    return full.status != 4;
                    }},
                  {name: "删除",click:"delete",type:"primary",icon:"el-icon-delete",auth:"crs36.lucky.delete"},
                  {name: "参与用户",click:"user",type:"primary",icon:"el-icon-edit"},
                  {name: "抽奖纪录",click:"record",type:"primary",icon:"el-icon-edit"},
                ]
              },
          ]
        }
      }
    }
  }
</script>
